import gql from "graphql-tag";
import { CardsRaw, UserCardsRaw } from "./Fragments";

export const GET_CARDS = gql`
  query cards($serie: String!) {
    cards(serie: $serie) {
      ...cardsRaw
    }
  }
  ${CardsRaw}
`;

export const GET_CARDS_ADMIN = gql`
  query cardsAdmin($maxSeason: Int) {
    cardsAdmin(maxSeason: $maxSeason) {
      season
      catalogSize
      cardsPerBooster
      boostersClosed
      boostersOpened
      boostersDistributed
      boosterHolders
      cardsInCirculation
      cardsFromBooster
      cardsFoil
      cardsUnique
      owners
    }
  }
`;

export const GET_CARDS_ADMIN_SEASON = gql`
  query cardsAdminSeason($season: Int!) {
    cardsAdminSeason(season: $season) {
      season
      mostOwned {
        number
        rarity
        name
        copies
      }
      leastOwned {
        number
        rarity
        name
        copies
      }
      topOwners {
        userId
        username
        copies
        distinctCards
      }
    }
  }
`;

export const GET_USER_CARDS = gql`
  query userCards($serie: String) {
    userCards(serie: $serie) {
      ...userCardsRaw
    }
  }
  ${UserCardsRaw}
`;
